/*
 * @Author: dengfang 36882215@qq.com
 * @Date: 2024-02-05 16:26:31
 * @LastEditors: dengfang 36882215@qq.com
 * @LastEditTime: 2024-02-21 20:54:42
 * @FilePath: /pophr-ms/src/lang/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/* eslint-disable */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { utilCookies } from '@/util/cookies'
import { getLocationQueryParam } from '@/util/util'
import axios from 'axios'
import loadLangPack from './loadLangPack'
export const langList = [
  {
    key: 'zh',
    label: '中文'
  },
  {
    key: 'en',
    label: 'English'
  },
  {
    key: 'th',
    label: 'ภาษาไทย'
  },
]
class Lang {
  constructor() {
    Vue.use(VueI18n)
    this.init()
  }
  init() {
    // 默认语言
    this.defaultLang = 'en'
    // 语言列表
    this.langList = langList
    // 当前语言
    this.currentLang = this.getLanguage()
    this.curLang = this.langList.filter(item => item.key === this.currentLang)[0]
    // elementUI语言包
    this.language = new Map([
      ['en', () => import('./en')],
      ['zh', () => import('./zh')],
      ['th', () => import('./th')],
    ])
    this.t = this.fun
    // 返回I18n给第三方用
    this.i18n = new VueI18n({
      locale: this.currentLang,
      silentTranslationWarn: true
    })
    this.loadLanguage()
    utilCookies.setLanguage(this.currentLang)
  }
  // 获取当前语言环境
  getLanguage() {
    // 如果是从官网链接过来语言取浏览器地址参数
    if (getLocationQueryParam('from') === "website") {
      utilCookies.setLanguage(getLocationQueryParam('lang'))
    }
    const lang = utilCookies.getLanguage() || localStorage.getItem('language')
    const localLanguage = lang ? lang.slice(0, 2) : false
    if (localLanguage) return localLanguage
    return this.defaultLang
  }
  // 获取远程语言包
  async getlang() {
    console.log('this.currentLang', this.currentLang)
    let lang = await import(`../i18n/${this.currentLang}.json`)
    window.lang = lang
    Vue.prototype.$t = this.fun
    // return loadLangPack(this.currentLang).then(() => {
    //   Vue.prototype.$t = this.fun
    // })
  }
  // 获取字段翻译
  fun(key, obj) {
    let res = window.lang[key]
    if (!res) {
      res = key
      // console.warn(` "${key}" 字典不存在！`)
      return res
    }
    if (obj) for (let k in obj) res = res.replace(new RegExp('{' + k + '}', 'g'), obj[k])
    return res
  }
  // 加载第三方语言包配置
  async loadLanguage() {
    //设置i18n的默认语言
    axios.defaults.headers.common['Accept-Language'] = this.currentLang //设置ajax请求的语言
    document.querySelector('html').setAttribute('lang', this.currentLang) //设置html的语言
    let langFun = this.language.get(this.currentLang)
    this.i18n.setLocaleMessage(this.currentLang, langFun ? (await langFun()).default : {})
  }
}
// use see: src/store/modules/settings.js
export const lang = new Lang()
// use see: src/permission.js
export const getlang = lang.getlang.bind(lang)
export default lang.i18n
